__turbopack_context__.v({
  "headerLink": "header-link-module-scss-module__FQKy7a__headerLink",
});
